
          import "Content.styles_rk5ox6.linaria.css";
          import { styled } from "@linaria/react";
import { typeStyle } from "@carvana/showroom-css-theme";

const calcLeftAttr = (direction, offsetX) => {
  const justification = direction.split("-")[1];

  const style = percent => `calc(${percent[0]}% + ${offsetX}px)`;

  switch (justification) {
    case "start":
      return style`6.5`;

    case "end":
      return style`88.5`;

    default:
      return style`48.5`;
  }
};

const commonArrowStyles = {
  borderWidth: "0 5px 6px",
  position: "absolute",
  borderStyle: "solid",
  width: 0
};
const Styles = /*#__PURE__*/styled("span")({
  name: "Styles",
  class: "sdsc1hs",
  vars: {
    "sdsc1hs-0": [props => props.color || "var(--cvna-color-blue-6)"],
    "sdsc1hs-1": [({
      width
    }) => width ? `${width}px` : ""],
    "sdsc1hs-2": [({
      top
    }) => top ? `${top}px` : ""],
    "sdsc1hs-3": [({
      left
    }) => left ? `${left}px` : ""],
    "sdsc1hs-5": [props => `calc(100% + ${props.arrowOffsetY || 0}px)`],
    "sdsc1hs-6": [({
      direction,
      arrowOffsetX
    }) => calcLeftAttr(direction, arrowOffsetX)],
    "sdsc1hs-7": [props => props.showArrow ? "block" : "none"],
    "sdsc1hs-8": [({
      color
    }) => color || "var(--cvna-color-blue-6)"],
    "sdsc1hs-10": [props => `calc(-6px + ${props.arrowOffsetY || 0}px)`],
    "sdsc1hs-15": [props => `calc(99% + ${props.arrowOffsetX || 0}px)`],
    "sdsc1hs-16": [props => `calc(50% - 5px + ${props.arrowOffsetY || 0}px)`],
    "sdsc1hs-20": [props => `calc(-3% + ${props.arrowOffsetX || 0}px)`]
  }
});
const CloseButton = /*#__PURE__*/styled("button")({
  name: "CloseButton",
  class: "c10dbq2e"
});
const Title = /*#__PURE__*/styled("span")({
  name: "Title",
  class: "t1rv8yz9"
});
const TitleContentWrapper = /*#__PURE__*/styled("span")({
  name: "TitleContentWrapper",
  class: "t109u1xh"
});
const BodyContentWrapper = /*#__PURE__*/styled("span")({
  name: "BodyContentWrapper",
  class: "bz4sugt"
});
export { Styles, CloseButton, Title, TitleContentWrapper, BodyContentWrapper };
          